import { FLAGS } from './flags';

/* ---------- gating (reads the resolved map from the login payload) ---------- */

export const getFeatureFlags = (userDetails) => (
  (userDetails && userDetails.featureFlags) || {}
);

// Strict === true: a missing key, null, "false" or a failed backend lookup all fail closed.
export const isFeatureEnabled = (userDetails, flagId) => getFeatureFlags(userDetails)[flagId] === true;

export const isTbtEnabled = userDetails => isFeatureEnabled(userDetails, FLAGS.TBT_GENERAL_ACCESS);
export const isTbtForceGDocsEnabled = userDetails => isFeatureEnabled(userDetails, FLAGS.TBT_FORCE_GDOCS_ACCESS);

export const isSuperAdmin = (userDetails) => !!(
  userDetails && userDetails.roleDetails && userDetails.roleDetails.isSuperAdmin === true
);

export const getLoggedInUserId = (userDetails) => (
  (userDetails && userDetails.roleDetails && userDetails.roleDetails.id) || ''
);

/* ---------- admin screens ---------- */

// featureFlags array -> { flagId: boolean }. Rows with no `enabled` (backend nulled them) are skipped.
export const toOverrideMap = featureFlags => {
  const map = {};
  (featureFlags || []).forEach(flag => {
    if (flag && typeof flag.flagId === 'string' && typeof flag.enabled === 'boolean') {
      map[flag.flagId] = flag.enabled;
    }
  });
  return map;
};

export const resolveFeatureFlags = (definitions, overrides) => {
  const map = overrides || {};
  const resolved = {};
  (definitions || []).forEach(def => {
    if (!def || def.active !== true) return;
    if (def.killSwitch === true) {
      resolved[def.id] = false;
      return;
    }
    resolved[def.id] = (map[def.id] === true || map[def.id] === false)
      ? map[def.id]
      : def.defaultEnabled === true;
  });
  return resolved;
};

export const isFlagEditable = (def, superAdmin) => (
  def.active === true &&
  def.killSwitch !== true &&
  (def.superAdminOnly !== true || superAdmin === true)
);

// Dirty check: only flags the admin actually changed, and only ones they were allowed to change.
export const buildFeatureFlagsPayload = (initialValues, currentValues, definitions, superAdmin, lastUpdatedBy) => (
  (definitions || [])
    .filter(def => isFlagEditable(def, superAdmin))
    .filter(def => currentValues[def.id] !== initialValues[def.id])
    .map(def => ({
      flagId: def.id,
      enabled: currentValues[def.id] === true,
      lastUpdatedBy
    }))
);


// WEBPACK FOOTER //
// ./src/featureFlags/index.js